import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
export default function LandingNavButtons(t0) {
  const $ = _c(6);
  const {
    loggedIn,
    hideSubscribe
  } = t0;
  if (loggedIn) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Button href="/magazine" rounded={true} size="xs" variant="special">Open app</Button>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Button href="/login" rounded={true} size="xs" variant="secondary">Log in</Button>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hideSubscribe) {
    t2 = !hideSubscribe && <Button href="#subscribe" native={true} rounded={true} size="xs" variant="special">Subscribe</Button>;
    $[2] = hideSubscribe;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}